function getSelectedValues(filter) {
    const arrValues = [];

    for (const filterItem of filter.querySelectorAll("select:not(.notFilter)")) {
        if (filterItem.value !== "*") {
            const filterDataset = filterItem.dataset.filter;
            arrValues.push(filterDataset + "=" +filterItem.value);
        }
    }

    return arrValues;
}

function filterEntries(collectionList,arrValues) {
    for (const entry of collectionList.querySelectorAll(".collectionListEntry")) {
        let showEntry = true;
        const arrFilterValuesByEntry = [];
        const filterValues = entry.dataset.filterValues.split(';');

        for (const filterValue of filterValues){
            const indexSplit = filterValue.indexOf("=");
            const filterGroup = filterValue.substring(0,indexSplit);
            const filterValuesToSplit = filterValue.substring(indexSplit+1,filterValue.length);
            if(filterGroup !== ""){
                if(!arrFilterValuesByEntry[filterGroup]){
                    arrFilterValuesByEntry.push(filterGroup);
                }
                const filterValueSplit = filterValuesToSplit.split(",");
                arrFilterValuesByEntry[filterGroup] = [...filterValueSplit];
            }
        }
        for (const selectedFilter of arrValues) {
            const indexSplit = selectedFilter.indexOf("=");
            const filterGroup = selectedFilter.substring(0,indexSplit);
            const filterValuesToSplit = selectedFilter.substring(indexSplit+1,selectedFilter.length);
            const arrFilterValuesByGroup = arrFilterValuesByEntry[filterGroup];
            if(arrFilterValuesByGroup){
                for (const selectedValue of filterValuesToSplit.split(",")){
                    if (!arrFilterValuesByGroup.includes(selectedValue)) {
                        showEntry = false;
                    }
                }
            }else{
                showEntry = false;
            }
        }
        if (showEntry) {
            entry.style.display = '';
            entry.classList.remove('hidden');
        } else {
            entry.style.display = 'none';
            entry.classList.add('hidden');
        }

    }
}

function filterEntriesBySearch(collectionList,value = "") {
    for (const entry of collectionList.querySelectorAll(".collectionListEntry:not(.hidden)")) {
        const entryText = entry.innerText.toLowerCase();
        entry.style.display = 'none';

        if(value === ""){
            entry.style.display = '';
        }else{
            if(entryText.includes(value.toLowerCase())){
                entry.style.display = '';
            }
        }
    }
}

function splitCommaOptions(filter) {
    for (const item of filter) {
        const value = item.value;
        if(value.includes(",")){
            const split = value.split(",");
            for(const splitItem of split){
                const newOpt = document.createElement("option");
                newOpt.value = splitItem;
                newOpt.innerHTML = splitItem;
                item.after(newOpt);
            }
            item.remove();
        }
    }
}

export function initLiveFilterCollection(collection) {

    const filter = document.querySelector('.collectionFilterJobs');
    if (filter) {

        const allSelect = filter.querySelectorAll('select:not(.notFilter)');
        const filterSearch = filter.querySelector('.filterJobsSearch');
        for (const select of allSelect) {
            const options = select.querySelectorAll('option');
            splitCommaOptions(options);

            select.addEventListener("change", function (e) {
                const selectedValues = getSelectedValues(filter);
                filterEntries(collection, selectedValues);
                if (filterSearch) {
                    filterSearch.value = "";
                }
                e.preventDefault();
            });
        }
        if (filterSearch) {
            filterSearch.addEventListener("keyup", function (e) {
                filterEntriesBySearch(collection, filterSearch.value);
                e.preventDefault();
            });
        }

        const locationSelect = filter.querySelector('#filterJobsLocation');
        if (locationSelect) {
            locationSelect.addEventListener("change", function (e) {
                const selectedValues = getSelectedValues(filter);
                filterEntries(collection, selectedValues);
                if (filterSearch) filterSearch.value = '';
                e.preventDefault();
            });
        }
    }
}